<h2 mat-dialog-title
    class="draggable-dialogue-header"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle>
    Add Contact
</h2>

<div>
    <mat-dialog-content>
        <div>
            <mat-form-field appearance="outline" class="input">
                <mat-label>Name</mat-label>
                <input matInput [ngModel]="ContactName" />
            </mat-form-field>
        </div>
        
        <div>
            <mat-form-field appearance="outline" class="input">
                <mat-label>Email</mat-label>
                <input matInput [ngModel]="Email" />
            </mat-form-field>
        </div>

        <div>
            <mat-form-field appearance="outline" class="input">
                <mat-label>Phone</mat-label>
                <input matInput [ngModel]="Phone" />
            </mat-form-field>
        </div>

        <div>
            <mat-form-field appearance="outline" class="input">
                <mat-label>Agency</mat-label>
                <input matInput [ngModel]="Agency" />
            </mat-form-field>
        </div>

        <div class="is-primary">
            <mat-checkbox [(ngModel)]="isPrimaryContact">Is this user the primary contact?</mat-checkbox>
        </div>

        <app-max-picker class="max-picker-component"
                        [maxMemberStyle]="'width: 70%;'"
                        [addButtonName]="'Set User'"
                        [scope]="'usersOnly'"
                        (addButtonClicked)="onUserSet($event)">
        </app-max-picker>
    </mat-dialog-content>

    <mat-dialog-actions>
        <button mat-flat-button
                [disabled]="SelectedUser==null"
                color="primary"
                class="theme-primary-btn"
                (click)="closeDialog(true)">
            Ok
        </button>
        <button mat-flat-button style="margin-left: 10px;" (click)="closeDialog(false)">Cancel</button>
    </mat-dialog-actions>
</div>
